import React, { ReactNode, useEffect } from 'react';
import { isConversationNotFoundError } from 'api/types';
import NotificationToast from './NotificationToast/NotificationToast';
import { useAppDispatch } from 'hooks';
import {
  WorkflowsState,
  addScreenReaderNotification,
} from 'reducers/workflows';

interface ErrorBannerProps {
  errorData: WorkflowsState['error'];
}

const ErrorBanner: React.FC<React.PropsWithChildren<ErrorBannerProps>> = ({
  errorData,
}) => {
  const getErrorTitle = (): string => {
    return 'Connection error';
  };

  const getErrorContent = (): ReactNode => {
    if (isConversationNotFoundError(errorData)) {
      return 'Please refresh the page.';
    }

    return 'Please start over or refresh the page.';
  };

  const getErrorContentAsString = (): string => {
    if (isConversationNotFoundError(errorData)) {
      return 'Please refresh the page.';
    }

    return 'Please start over or refresh the page.';
  };

  const title = getErrorTitle();
  const content = getErrorContent();
  const contentAsString = getErrorContentAsString();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (errorData) {
      dispatch(
        addScreenReaderNotification(`Error: ${title}. ${contentAsString}`),
      );
    }
  }, [contentAsString, dispatch, errorData, title]);

  if (!errorData) return null;

  return <NotificationToast content={content} title={title} />;
};

export default ErrorBanner;
